<script>
    import { required } from "vuelidate/lib/validators";
    import Customers from '@/services/Customers';
    import validationMessages from '@/components/validations'
    import Multiselect from "vue-multiselect";
    import "vue-multiselect/dist/vue-multiselect.min.css";
    import vue2Dropzone from "vue2-dropzone";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";

    export default {
        components: {
            validationMessages,
            Multiselect,
            vueDropzone: vue2Dropzone,
        },
        props: {

                modalData: {
                    type: Object,
                    default: () => ({
                        company_id: '',
                        name: '',
                        description: '',
                        website: '',
                        logo_url: '',
                        company_image: '',
                        background_color: '',
                        club_members: [] ,
//                        verified_checked : false ,
                    }),
                },
        },
        watch: {
            modalData: {
                immediate: true,
                deep: true,
                handler(newVal) {
                    if (newVal) {
                        this.company_id = newVal.company_id || '';
                        this.name = newVal.name || '';
                        this.website = newVal.website || '';
                        this.description = newVal.description || '';
                        this.background_color = newVal.background_color || '';
                        this.logo_url = newVal.logo_url || '';
                        this.photoDeleted = false;
                        this.LogoUrlDeleted = false;
                    }
                },
            },
        },
        validations: {
            name: {
                required
            },
        },
        data() {
            return {
                csrf_token: localStorage.getItem('csrf_token'),
                id_e: '',
                company_id: '' ,
                name: '',
                website: '',
                description: '',
                acceptedFileTypeErrorMessage:'',
                acceptedFileTypeError:false,
                submitted: false,
                showModal: false,
                tryingToEdit: false,
                photoDeleted: false,
                LogoUrlDeleted : false ,
                active : false ,
                dropzoneOptions_company_image: {
                    url: '/',
                    autoProcessQueue: false,
                    addRemoveLinks: true,
                    thumbnailWidth: 200,
                    thumbnailMethod: 'contain',
                    maxFilesize: 5,
                    acceptedFiles: 'image/*',
                    maxFiles: 1,
                },
                dropzoneOptions_logo_url: {
                    url: '/',
                    autoProcessQueue: false,
                    addRemoveLinks: true,
                    thumbnailWidth: 200,
                    thumbnailMethod: 'contain',
                    maxFilesize: 5,
                    acceptedFiles: 'image/jpeg,image/png,image/gif,image/bmp,image/webp',
                    maxFiles: 1,
                },
                availableLabels: [],
                selectedLabels: [],
                initialLabelIds: [],
            };
        },
        methods: {
            refreshData() {
                this.$emit('onRefresh')
            },
            closeModal() {
                this.showModal = false;
                this.resetProps();
                this.photoDeleted = false;
                this.LogoUrlDeleted = false;
            },
            resetProps() {
                this.submitted = false;
                this.name = '';
                this.website = '';
                this.description = '';
                this.selectedLabels = [];
                this.initialLabelIds = [];
                this.availableLabels = [];
            },
            async fetchCompanyLabels() {
                try {
                    const response = await Customers.getCustomersLabel({
                        is_company_label: 1,
                        active: 1,
                    });
                    this.availableLabels = response.data.data || [];
                } catch (error) {
                    this.availableLabels = [];
                }
            },
            labelBadgeStyle(label) {
                const bg = label.color || "#6c757d";
                return {
                    backgroundColor: bg,
                    color: this.labelTextColor(bg),
                };
            },
            labelTextColor(hex) {
                if (!hex) {
                    return "#fff";
                }
                const color = hex.replace("#", "");
                if (color.length !== 6) {
                    return "#fff";
                }
                const r = parseInt(color.substring(0, 2), 16);
                const g = parseInt(color.substring(2, 4), 16);
                const b = parseInt(color.substring(4, 6), 16);
                const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
                return luminance > 0.6 ? "#212529" : "#fff";
            },
            syncSelectedLabelsFromCompany() {
                const companyLabels = this.modalData?.labels || [];
                const companyLabelIds = companyLabels.map((label) => Number(label.id));

                companyLabels.forEach((companyLabel) => {
                    const exists = this.availableLabels.some(
                        (option) => Number(option.id) === Number(companyLabel.id)
                    );
                    if (!exists) {
                        this.availableLabels.push({ ...companyLabel });
                    }
                });

                this.selectedLabels = this.availableLabels.filter((option) =>
                    companyLabelIds.includes(Number(option.id))
                );
                this.initialLabelIds = [...companyLabelIds];
            },
            buildLabelChanges() {
                const selectedIds = this.selectedLabels.map((label) => Number(label.id));
                const initialIds = this.initialLabelIds.map((id) => Number(id));
                return {
                    label_ids: selectedIds.filter((id) => !initialIds.includes(id)),
                    remove_label_ids: initialIds.filter((id) => !selectedIds.includes(id)),
                };
            },
            async onModalShown() {
                await this.fetchCompanyLabels();
                this.syncSelectedLabelsFromCompany();
            },
            // selectFileHome(files) {
            //     setTimeout(() => {
            //         let queuedFiles = this.$refs.myVueDropzone_company_image.getQueuedFiles();
            //
            //         if (queuedFiles.length > 1) {
            //             this.failedmsg('You can only select one image');
            //
            //             files.forEach((value) => {
            //                 this.$refs.myVueDropzone_company_image.removeFile(value);
            //             });
            //         }
            //         this.company_image = queuedFiles[0];
            //         this.photoDeletedHome = false;
            //     }, 250);
            // } ,
            selectLogoUrl(files) {
                setTimeout(() => {
                    let queuedFiles = this.$refs.myVueDropzone_logo_url.getQueuedFiles();
                    console.log(files,'files');
                    if(files[0].accepted == false){
                      console.log('File not accepted');
                      this.acceptedFileTypeErrorMessage = 'File not accepted | Accepted formats are png, jpg, gif, bmp, webp | Max size 5MB';
                      this.acceptedFileTypeError = true;
                    }else{
                      this.acceptedFileTypeErrorMessage = '';
                      this.acceptedFileTypeError = false;
                    }

                    console.log(queuedFiles,'queuedFiles');
                    if (queuedFiles.length > 1) {
                        this.failedmsg('You can only select one image');

                        files.forEach((value) => {
                            this.$refs.myVueDropzone_logo_url.removeFile(value);
                        });
                    }
                    this.logo_url = queuedFiles[0];
                    this.photoDeleted = false;
                }, 250);
            } ,

            // deleteImage() {
            //     this.photoDeleted = true;
            //     this.company_image = '';
            // },

            deleteLogoUrl() {
                this.LogoUrlDeleted = true;
                this.logo_url = '';
            },

            async editCompany(){
              if(this.acceptedFileTypeError) return;
                this.tryingToEdit = true;
                this.submitted = true;


                    try {

                        const company_id = this.company_id;
                        const { label_ids, remove_label_ids } = this.buildLabelChanges();
                        const formData = new FormData();
                        formData.append("name", this.name);
                        formData.append("company_id", this.company_id);
                        formData.append("description", this.description);
                        formData.append("website", this.website || "");
                        formData.append("background_color", this.background_color || "");
                        formData.append("csrf_token", this.csrf_token);
                        formData.append("_method", "PATCH");

                        if (this.logo_url && typeof this.logo_url === "object") {
                            const file = this.logo_url.file || this.logo_url;
                            formData.append("logo_url", file);
                        } else if (this.logo_url && !this.LogoUrlDeleted) {
                            formData.append("logo_url", this.logo_url);
                        }

                        label_ids.forEach((labelId) => formData.append("label_ids[]", labelId));
                        remove_label_ids.forEach((labelId) => formData.append("remove_label_ids[]", labelId));

                        await Customers.editCompany(company_id, formData).then((response) => {
                            this.successmsg("Changes has been saved");
                            this.closeModal();
                            this.refreshData();
                        }).catch(error => {
                            this.error = error.response.data.error ? error.response.data.error : "";
                            this.failedmsg(this.error)
                        }).finally(() => {
                            this.refreshData()
                            this.tryingToEdit = false
                        })
                    } catch (error) {
                        this.error = error.response.data.error ? error.response.data.error : "";
                        this.failedmsg(this.error)
                    }

                this.tryingToEdit = false;
            },
        }
    };</script>

<template>
    <b-modal @hidden="resetProps" @shown="onModalShown" v-model="showModal" id="company_edit" title="Edit Company" title-class="font-18" centered>
        <form @submit.prevent="editCompany">
            <input style="display:none" v-model.trim="modalData.company_id" >
            <b-form-group label="Company Name" label-for="formrow-company-name-input" class="mb-3">
                <b-form-input
                        v-model.trim="modalData.name"
                        type="text"
                        id="name"
                        aria-describedby="name-feedback"
                        :class="{
                            'is-invalid': submitted && $v.name.$error,
                        }"
                ></b-form-input>
                <validationMessages v-if="submitted" :fieldName="'Company Name'" :validationName="$v.name"></validationMessages>
            </b-form-group>
            <b-form-group label="Description" label-for="formrow-description-input" class="mb-3">
                <b-form-input
                        v-model.trim="description"
                        type="text"
                        id="description"
                        aria-describedby="description-feedback"
                ></b-form-input>
            </b-form-group>
            <b-form-group label="Website" label-for="formrow-website-input" class="mb-3">
                <b-form-input
                        v-model.trim="website"
                        type="text"
                        id="website"
                        aria-describedby="website-feedback"
                ></b-form-input>
            </b-form-group>
            <b-form-group label="Background Color" label-for="formrow-background-color-input" class="mb-3">
                <b-form-input
                        v-model.trim="background_color"
                        type="color"
                        id="background_color"
                        aria-describedby="website-feedback"
                        class="form-control form-control-color"
                ></b-form-input>
            </b-form-group>
            <b-form-group label="Labels" label-for="edit-company-labels" class="mb-3">
                <multiselect
                    id="edit-company-labels"
                    class="label-multiselect"
                    v-model="selectedLabels"
                    :options="availableLabels"
                    :multiple="true"
                    :close-on-select="false"
                    label="name"
                    track-by="id"
                    placeholder="Select labels"
                >
                    <template slot="option" slot-scope="{ option }">
                        <span
                            class="label-option-swatch me-2"
                            :style="{ backgroundColor: option.color || '#6c757d' }"
                        />
                        <span>{{ option.name }}</span>
                    </template>
                    <template slot="tag" slot-scope="{ option, remove }">
                        <span class="multiselect__tag label-multiselect-tag" :style="labelBadgeStyle(option)">
                            {{ option.name }}
                            <i class="multiselect__tag-icon" @click="remove(option)" aria-hidden="true"></i>
                        </span>
                    </template>
                </multiselect>
            </b-form-group>
            <!--<b-form-checkbox-group>-->
                <!--<div class="form-check form-switch form-switch-lg mb-3" >-->
                    <!--<input v-model="verified_checked"-->
                           <!--type="checkbox"-->
                           <!--class="form-check-input"-->
                           <!--id="companyStatus"-->
                    <!--/>-->
                    <!--<label class="form-check-label" for="companyStatus">Active</label>-->
                <!--</div>-->
            <!--</b-form-checkbox-group>-->

<!--            <div class="form-group " >-->
<!--                <label for="company_image">Company Image:</label>-->
<!--                <template v-if="!photoDeleted && company_image">-->
<!--                    <b-form-group label-for="image" class="mb-3 text-center image-area">-->
<!--                        <img :src="company_image" alt="" width="200" class="img-thumbnail" />-->
<!--                    </b-form-group>-->
<!--                    <div class="text-center mt-3">-->
<!--                        <a class="btn text-danger" v-b-tooltip.hover title="Delete Image" @click="deleteImage">-->
<!--                            <i class="uil uil-trash-alt font-size-18"></i>-->
<!--                        </a>-->
<!--                    </div>-->
<!--                </template>-->
<!--                <template v-else>-->
<!--                    <vue-dropzone-->
<!--                            id="dropzone_company_image"-->
<!--                            ref="myVueDropzone_company_image"-->
<!--                            :use-custom-slot="true"-->
<!--                            :options="dropzoneOptions_company_image"-->
<!--                            @vdropzone-files-added="selectFileHome"-->
<!--                            no-progress-bar-->
<!--                    >-->
<!--                        <div class="dropzone-custom-content">-->
<!--                            <i class="display-4 text-muted bx bxs-cloud-upload"></i>-->
<!--                            <h4>Drop file here or click to upload.</h4>-->
<!--                        </div>-->
<!--                    </vue-dropzone>-->
<!--                </template>-->
<!--            </div>-->
            <div class="form-group " >
                <label for="logo_url">Logo Image:</label>
                <template v-if="!LogoUrlDeleted && logo_url">
                    <b-form-group label-for="image" class="mb-3 text-center image-area">
                        <img  :src="`${logo_url}?ts=${Date.now()}`" alt="" width="200" class="img-thumbnail" />
                    </b-form-group>
                    <div class="text-center mt-3">
                        <a class="btn text-danger"  title="Delete Image" @click="deleteLogoUrl">
                            <i class="uil uil-trash-alt font-size-18"></i>
                        </a>
                    </div>
                </template>
                <template v-else>
                    <vue-dropzone
                            id="dropzone_logo_url"
                            ref="myVueDropzone_logo_url"
                            :use-custom-slot="true"
                            :options="dropzoneOptions_logo_url"
                            @vdropzone-files-added="selectLogoUrl"
                            no-progress-bar
                    >
                        <div class="dropzone-custom-content">
                            <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                            <h4>Drop file here or click to upload.</h4>
                        </div>
                    </vue-dropzone>
                    <p v-if="acceptedFileTypeError" class="text-danger">{{acceptedFileTypeErrorMessage}}</p>
                </template>
            </div>
            <input type="hidden" name="csrf_token" v-model="csrf_token">
        </form>
        <template v-slot:modal-footer>
            <b-button variant="light" @click="closeModal">Close</b-button>
            <b-button variant="primary" @click="editCompany" :disabled="tryingToEdit">
                <b-spinner v-show="tryingToEdit" small></b-spinner>
                Submit</b-button>

        </template>
    </b-modal>
</template>

<style scoped>
.label-option-swatch {
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 3px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    vertical-align: middle;
}

</style>
